import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import numeral from "numeral";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import Button from '../../components/Button';
// import Chip from '@material-ui/core/Chip';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconOpenInNew from "@material-ui/icons/OpenInNew";
import { db } from "../../engine";

import * as Color from "../../components/Color";

const StyledTableRow = styled(TableRow)`
  cursor: pointer;
  &:hover {
    background: #fafafa;
  }
`;

const Chip = styled.a`
  border-radius: 16px;
  margin: 10px 0;
  padding: 4px 0;
  background-color: #616161;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #fff;
`;

const mapStateToProps = (state, ownProps) => {
  // console.log('ProjectTableRow', state);
  const data = _.get(state, ["newProjects", "fullProjects", ownProps.id]);
  return {
    data,
  };
};
export default connect(mapStateToProps)(
  class extends React.PureComponent {
    hasValidTheAgentLink = () => {
      const { data } = this.props;
      const theAgentLink = _.get(data, "integrations.TheAgent.ProjectLink");
      return !_.isEmpty(theAgentLink) && theAgentLink !== "N/A";
    };

    render() {
      const { id, onClick, data } = this.props;
      // const { data } = this.state;
      const title = _.get(data, "title", "");
      return (
        <StyledTableRow hover onClick={onClick}>
          {/* <TableCell style={{ color: '#AAA' }}>{id}</TableCell> */}
          <TableCell>
            <div>{_.get(title, "en", title)}</div>
            <div style={{ fontSize: '0.8em', opacity: 0.75 }}>{id}</div>
          </TableCell>
          <TableCell>
            {_.get(data, "code")}
          </TableCell>
          <TableCell align="right">
            {numeral(_.get(data, "resalePriceSqm")).format("0,0a")}
          </TableCell>
          <TableCell align="right">
            {numeral(_.get(data, "rentalPriceSqm")).format("0,0")}
          </TableCell>
          <TableCell>
            {/* {_.get(data, 'integrations.TheAgent.ProjectLink') && <a href={_.get(data, 'integrations.TheAgent.ProjectLink')} target="_blank">Link</a> */}
            {this.hasValidTheAgentLink() && (
              <Chip
                onClick={(e) => e.stopPropagation()}
                href={_.get(data, "integrations.TheAgent.ProjectLink")}
                target="_blank"
              >
                {`ID: ${_.get(data, "integrations.TheAgent.ProjectID")}`}
              </Chip>
            )}
            {/* label={`ID: ${_.get(data, 'integrations.TheAgent.ProjectID')}`}
              target="_blank"
              // component="a"
              // to={_.get(data, 'integrations.TheAgent.ProjectLink')}
              clickable
              onClick={e => e.stopPropagation()}
              onDelete={console.log}
              deleteIcon={<IconOpenInNew style={{ fontSize: '0.9em' }} />}
            /> */}
            {/* <Button color="primary" variant="outlined" component={Link} target="_blank" to={_.get(data, 'integrations.TheAgent.ProjectLink')}>
              <span style={{ whiteSpace: 'nowrap' }}>ID: {_.get(data, 'integrations.TheAgent.ProjectID')}</span> <IconOpenInNew style={{ fontSize: '0.875rem', marginLeft: 6 }} />
            </Button> */}
          </TableCell>
        </StyledTableRow>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/admin/components/ProjectTableRow.js